// extracted by mini-css-extract-plugin
export var bubble = "_3y-0";
export var container = "_3y-f";
export var contrastBorder = "_3y-g";
export var greyOut = "_3y-2";
export var initialsColor0 = "_3y-3";
export var initialsColor1 = "_3y-4";
export var initialsColor10 = "_3y-d";
export var initialsColor11 = "_3y-e";
export var initialsColor2 = "_3y-5";
export var initialsColor3 = "_3y-6";
export var initialsColor4 = "_3y-7";
export var initialsColor5 = "_3y-8";
export var initialsColor6 = "_3y-9";
export var initialsColor7 = "_3y-a";
export var initialsColor8 = "_3y-b";
export var initialsColor9 = "_3y-c";
export var initialsWrapper = "_3y-1";
export var large = "_3y-l";
export var medium = "_3y-k";
export var mediumSmall = "_3y-j";
export var mediumSmallMedium = "_3y-o";
export var micro = "_3y-h";
export var small = "_3y-i";
export var tiny = "_3y-n";
export var xTiny = "_3y-m";